<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>d</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.question.open') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ $t('pages.questions.OpenModification.title.name') }}</h1>

      <open-form is-modification
                 @save="save"
      />
    </section>
  </div>
</template>

<script>
import OpenForm from '@/components/questions/formOpen.vue'
import { mapActions } from 'vuex'

export default {
  name: 'questionOpenModification',
  components: {
    OpenForm
  },
  methods: {
    ...mapActions('Questions', [
      'saveQuestion'
    ]),
    async save (payload) {
      await this.saveQuestion(
        {
          question: payload.question,
          redirect: payload.saveType === 'save'
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
</style>
